// @flow
const RESET_APP = 'APP:RESET';

export {
  // eslint-disable-next-line import/prefer-default-export
  RESET_APP,
};
